/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-01 10:21:04
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 19:42:05
 */
const ResultPage = Object.freeze(["paymentSuccess"]); //[,成功]
import { SOURCE } from "@/utils/constants";
const { MINIAPP, APP_IOS, APP_ANDROID } = SOURCE;
import { sys } from '@/utils'

/**
 * 监听来自APP支付结果的消息
 * @param {*} result 0: 成功 其他(-1/-2):失败
 */
window.onMessageFromPayBack = function(result) {
  // console.log(result);
  window.vm.$loading.hide();
  console.log('onMessageFromPayBack', result);
  if(result == 0) {
    window.vm.$router.push({ name: ResultPage[result] });
  }
};
/**
 * 监听来自APP的消息
 * @param {*} type 0: 登录 1:退出登录
 * @param {*} userId 0: 用户id type==0 必传
 * @param {*} sessionId 0: 用户id type==0 必传
 */
window.onMessageFromLoginBack = function(type, userId, sessionId) {
  console.log('onMessageFromLoginBack', type, userId, sessionId);
  if (type == 0) {
    window.vm.$store.dispatch("init/onLoginBack", {userId, sessionId});
  } else {
    window.vm.$store.dispatch("init/clear");
  }
};

/**
 * 监听来自APP的消息
 * @param {String|Number} type 0: 登录 1:支付 2:后退
 * @param {String|Number} result type =0 (0:登入 1:登出 )        必填
 *                               type =1 (0:支付成功 非1(-1/-2):支付失败)  必填
 *                               type =2                       非必填
 * @param {String|Number} userId 用户id type==0 && result ==0 必传
 * @param {String} sessionId     sessionId type==0 && result ==0  必传
 */
window.onMessageFromApp = function({ type, userId, sessionId, result }) {
  switch (+type) {
    case 0:
      if (result == 0) {
        window.vm.$store.dispatch("init/onLoginBack", {userId, sessionId});
      } else {
        window.vm.$store.dispatch("init/clear");
      }
      break;
    case 1:
      if(result == 0) {
        window.vm.$router.push({ name: ResultPage[result] });
      }
      break;
    case 2:
      window.onClickLeft();
      break;
    default:
      break;
  }
};

/**
 * 监听APP返回
 */
window.onClickLeft = function() {
  const id = window.vm.myUtils.getUrlParms("id");
  if (!id) {
    window.vm.$router.go(-1);
    return;
  }
  const _p = { type: 1 };
  window.jump(_p);
};

/**
 * 监听APP导航显示/隐藏 路由拦截
 * @param {Boolean} status status = 0/1 隐藏/显示
 * @param {String|Number} type type = 2
 * @param {String|Number} show show = 0 隐藏
 *                             show = 1 显示
 */
window.handleTabBar = function(status) {
  let params = {type: 2, show: status};
  window.jump(params);
}

/**
 * 调起APP电话功能
 */
window.toAppPhone = function() {
  let params = {type: 6, tel: '400-8060-999'};
  window.jump(params);
}

window.jump = function(_p) {
  switch (+sys.ids.source) {
    case MINIAPP:{
      const toAppId = sys.ids.appId
      window.vm.$socket && window.vm.$socket.emit('exchange',{'toAppId':toAppId,target:'jumpNativeApp',payload:_p})
      break;
    }
    case APP_ANDROID:{
      window.myjs && window.myjs.jumpNativeApp(JSON.stringify(_p));
      break;
    }
    case APP_IOS:{
      window.webkit.messageHandlers.jumpNativeApp.postMessage(JSON.stringify(_p));
      break;
    }
    default:
      break;
  }
}
